// Sperre, solange kein SEPA-Lastschriftmandat vorliegt.
//
// Bewusst keine Totalsperre des Zugangs: ein eingefrorener Kunde käme nicht
// einmal mehr an das Formular, das die Sperre auflöst — er müsste anrufen und
// warten. Hier ist die Anwendung zu und genau ein Weg bleibt offen. Wer zahlen
// will, kann es in zwei Minuten selbst erledigen.
//
// Die Daten des Betriebs bleiben dabei unberührt. Das steht auch so da, weil
// genau diese Sorge der Grund ist, warum jemand an dieser Stelle aussteigt.
import { useAuth } from '../../../gemeinsam/lib/AuthContext';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { Hinweis, Karte } from '../../../gemeinsam/komponenten/Basis';
import { LogoKachel } from '../../firma/komponenten/Logo';
import SepaMandat from '../../bank/komponenten/SepaMandat';

export default function MandatErforderlich() {
  const { t } = useSprache();
  const { mandant, abmelden, aktualisieren } = useAuth();

  return (
    <div
      style={{
        // Oben die Statusleiste, unten die Home-Leiste freihalten; im Browser
        // sind beide Werte 0 und es bleibt bei den 3rem von vorher.
        paddingTop: 'calc(3rem + var(--sicher-oben))',
        paddingBottom: 'calc(3rem + var(--sicher-unten))',
      }}
      className="flex min-h-full items-center justify-center bg-gradient-to-b from-slate-100 to-slate-200 px-4 dark:from-slate-950 dark:to-slate-900">
      <div className="w-full max-w-lg">
        <div className="mb-6 text-center">
          <LogoKachel groesse="gross" klasse="mx-auto mb-4 shadow-lg shadow-marke-600/25" />
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">{t('mandat.pflichtTitel')}</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{mandant?.name}</p>
        </div>

        <Karte>
          <div className="space-y-4 p-6">
            <Hinweis art="warnung">{t('mandat.pflichtText')}</Hinweis>
            <SepaMandat beiErteilt={aktualisieren} />
            <button type="button" onClick={abmelden}
                    className="w-full text-center text-xs text-slate-500 hover:underline dark:text-slate-400">
              {t('aktion.abmelden')}
            </button>
          </div>
        </Karte>
      </div>
    </div>
  );
}
